import { gql } from '@apollo/client';

import client from '../../../../../../core/services/graphql';

const GET_QUOTES_DATA_QUERY = gql`
  query Analytics($projectId: ID!, $segmentId: ID) {
    analytics(projectId: $projectId, segmentId: $segmentId) {
      quotes {
        quoteId
        testerId
        questionId
        questionGroupName
        sentence
        important
        sentimentBySentence
        sentimentByTask
        sentimentByParticipant
        videoTime
        removed
        profileId
        profile {
          id
          firstName
        }
      }
    }
  }
`;

export const getQuotesByProjectId = async (projectId, segmentId) => {
  const { data } = await client.getClient().query({
    query: GET_QUOTES_DATA_QUERY,
    variables: { projectId, segmentId },
  });

  return data.analytics;
};

const GET_QUOTES_KEYS_QUERY = gql`
  query Analytics($projectId: ID!, $segmentId: ID) {
    analytics(projectId: $projectId, segmentId: $segmentId) {
      quotesKeys(removed: false) {
        quotesKeyId
        testerId
        questionGroupId
        questionGroupName
        threeSentences
        keyword
        keywordCount
        videoTime
        profileId
        removed
        profile {
          firstName
        }
      }
    }
  }
`;

export const getQuotesKeysByProjectId = async (projectId, segmentId) => {
  const { data } = await client.getClient().query({
    query: GET_QUOTES_KEYS_QUERY,
    variables: { projectId, segmentId },
    fetchPolicy: 'no-cache', // Using no-cache fix the flicker, when switching quickly from 'quotes tab' to other tabs.
  });

  return data.analytics;
};
